export default __webpack_public_path__ + "static/media/intentions1.edb270a8.png";